import MoreVertSharpIcon from '@mui/icons-material/MoreVertSharp';
import { ButtonGroup, Stack, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { Dropdown } from '../dropdown';

export type ActionBarProps = {
  primaryAction?: React.ReactNode;
  secondaryActions?: React.ReactNode;
  title?: React.ReactNode;
};

export const ActionBar: FunctionComponent<ActionBarProps> = (props) => {
  const { primaryAction, secondaryActions, title } = props;
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: 5 }}
    >
      {title && <Typography variant="h4">{title}</Typography>}
      {primaryAction && !secondaryActions && primaryAction}
      {primaryAction && secondaryActions && (
        <ButtonGroup variant="contained" aria-label="split button">
          {primaryAction}
          {secondaryActions && (
            <Dropdown actionComponent={<MoreVertSharpIcon />}>
              <Stack sx={{ p: 1 }}>{secondaryActions}</Stack>
            </Dropdown>
          )}
        </ButtonGroup>
      )}
    </Stack>
  );
};
